import React from 'react';
import _ from 'lodash';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {getItemsOfCostType} from 'common/utils';
import {CARD_TYPES, FOID_FOR_COST_TYPE} from 'common/requestDetails/constants.js';

export class RosterListener extends React.Component {
  state = {
    initializing: true,
  };

  componentDidMount() {
    const {data, itemData} = this.props;
    const grantLoading = _.get(this.props, 'grantLoading', true);
    if (!grantLoading && data === undefined && itemData !== undefined) {
      this.generateRoster();
    }
  }

  componentDidUpdate() {
    const {data, fundingStreams, itemData} = this.props;
    const grantLoading = _.get(this.props, 'grantLoading', true);
    const {initializing} = this.state;
    if (
      !grantLoading &&
      data === undefined &&
      initializing &&
      fundingStreams &&
      itemData
    ) {
      this.generateRoster();
    }
  }

  generateRoster = () => {
    const {
      fundingStreams,
      entityDataPath,
      entityType,
      itemData,
      fundingOpportunityId,
      rosterListenerCostType,
    } = this.props;

    // only one cost type for now that goes to the roster
    let awardedBundledItems = getItemsOfCostType(
      fundingStreams,
      itemData,
      rosterListenerCostType
        ? rosterListenerCostType
        : FOID_FOR_COST_TYPE[fundingOpportunityId] === undefined
        ? CARD_TYPES.STAFFING_BUNDLED
        : FOID_FOR_COST_TYPE[fundingOpportunityId]
    );

    let rosterBundledPositions = _.flatMap(
      _.map(awardedBundledItems, (item) => {
        return _.map(_.range(_.get(item, ['cost', 0, 0, 'quantity'], 0)), (index) => ({
          employees: [],
          awardedId: item.awardedId,
          positionId: index,
        }));
      })
    );

    this.setState(
      {
        initializing: false,
      },
      () => this.props.saveEntityData(entityDataPath, entityType, rosterBundledPositions)
    );
  };

  render() {
    return null;
  }
}

export default connectDynamic(RosterListener);
